import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Text } from '@mallpay/orbis';
import { Image } from '@mallpay/orbis';
import { Trans, useTranslation } from 'react-i18next';
import { mergeClasses } from '@/utils/style';
interface BankSectionProps {
  className?: string;
}
export const BankSection: React.FC<BankSectionProps> = t0 => {
  const $ = _c(27);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["revolvingLoan"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== className) {
    t2 = mergeClasses("mt-20 flex w-full flex-col items-center", className);
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("revolvingLoan:bank.title");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <Image loading="lazy" src="/images/sections/revolvingLoan/bank/cs/bank.png" alt={t3} width={327} height={375} className="mx-auto block lg:hidden" />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      csob: <span className="text-blue-500" />
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  if ($[8] !== t) {
    t6 = <Text className="text-center text-5xl font-bold lg:text-left"><Trans t={t} i18nKey="revolvingLoan:bank.title" components={t5} /></Text>;
    t7 = t("revolvingLoan:bank.subtitle");
    $[8] = t;
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <p>{t7}</p>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t8) {
    t9 = <div className="flex max-w-xl flex-col gap-4 px-4 text-center lg:px-0 lg:text-left">{t6}{t8}</div>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("revolvingLoan:bank.title");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <Image loading="lazy" src="/images/sections/revolvingLoan/bank/cs/bank.png" alt={t10} width={327} height={375} className="hidden lg:block" />;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t4 || $[22] !== t9) {
    t12 = <div className="mb-15 flex w-full flex-col items-center justify-center gap-12 lg:mb-0 lg:flex-row lg:gap-[100px]">{t4}{t9}{t11}</div>;
    $[20] = t11;
    $[21] = t4;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t2) {
    t13 = <div className={t2}>{t12}</div>;
    $[24] = t12;
    $[25] = t2;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};